import Blockly from 'blockly/browser'
import { defineBlock, defineStmtBlock } from '../Util'
import _ from 'lodash'

const mutatorContainerName = 'try_catch_mutator_container'
const mutatorName = 'try_catch_mutator'
const catchBlockName = 'try_catch_catch_item'
const finallyBlockName = 'try_catch_finally_item'
const inputNames = {
  try: 'tryPart',
  catch: 'catchPart',
  finally: 'finallyPart'
}

defineStmtBlock(finallyBlockName, {
  message0: `finally`,
  args0: []
})
defineStmtBlock(catchBlockName, {
  message0: `catch`,
  args0: []
})
defineBlock(mutatorContainerName, {
  message0: `error logic %1 %2`,
  args0: [
    {
      type: 'input_dummy'
    },
    {
      type: 'input_statement',
      name: 'PARTS'
    }
  ]
})
Blockly.Extensions.registerMutator(
  mutatorName,
  {
    mutationToDom() {
      // Serialize mutator info to xml
      if (this.parts === null) {
        return []
      }
      let container = document.createElement('mutation')
      container.setAttribute('parts', this.parts)
      return container
    },
    domToMutation(container) {
      // Restore mutator info from xml
      let partsAttr = container.getAttribute('parts')
      if (partsAttr !== null) {
        this.parts = partsAttr ? partsAttr.split(',').map(x => x.trim()) : []
      }
      this.updateShape_()
    },
    decompose(workspace) {
      // Populate the mutator's dialog with the block's components
      let containerBlock = workspace.newBlock(mutatorContainerName)
      containerBlock.initSvg()
      let connection = containerBlock.getInput('PARTS').connection
      for (let i = 0; i < this.parts.length; i++) {
        let itemBlock = workspace.newBlock(`try_catch_${this.parts[i]}_item`)
        itemBlock.initSvg()
        connection.connect(itemBlock.previousConnection)
        connection = itemBlock.nextConnection
      }
      return containerBlock
    },
    compose(containerBlock) {
      // Reconfigure this block based on the mutator dialog's components
      let itemBlock = containerBlock.getInputTargetBlock('PARTS')
      // Get new thing selection
      let newParts = []
      while (itemBlock) {
        if (itemBlock.type === catchBlockName) {
          newParts.push('catch')
        } else if (itemBlock.type === finallyBlockName) {
          newParts.push('finally')
        }
        itemBlock = itemBlock.nextConnection && itemBlock.nextConnection.targetBlock()
      }
      let oldParts = this.parts
      this.parts = newParts
      this.updateShape_(oldParts)
    },
    updateShape_(oldParts = []) {
      const toBeAddedParts = _.difference(this.parts, oldParts)
      const toBeRemovedParts = _.difference(oldParts, this.parts)

      for (let i = 0; i < toBeAddedParts.length; i++) {
        if (!this.getInput(inputNames[toBeAddedParts[i]])) {
          const newInput = this.appendStatementInput(inputNames[toBeAddedParts[i]])
          newInput.appendField(toBeAddedParts[i])
          if (toBeAddedParts[i] === 'catch') {
            newInput.appendField(new Blockly.FieldTextInput('error'), 'errorVariable')
          }
        }
      }
      for (let i = 0; i < toBeRemovedParts.length; i++) {
        const inputName = `${toBeRemovedParts[i]}Part`
        this.removeInput(inputName)
      }
      if (this.parts.length > 1) {
        this.moveInputBefore(inputNames.catch, inputNames.finally)
      }
    }
  },
  function() {
    this.parts = ['catch']
  }, // catch selected by default
  [catchBlockName, finallyBlockName]
)

defineBlock(
  'exceptions_try_catch',
  {
    message0: 'try %1',
    args0: [
      {
        type: 'input_statement',
        name: inputNames.try
      }
    ],
    inputsInline: false,
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Handle errors gracefully by wrapping risky code in this block',
    colour: Blockly.Msg.LOGIC_HUE,
    helpUrl:
      'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/try...catch',
    mutator: mutatorName
  },
  function(block) {
    const statementsTryPart = Blockly.JavaScript.statementToCode(block, inputNames.try)
    const textErrorVariable = block.getFieldValue('errorVariable')
    const statementsCatchPart = Blockly.JavaScript.statementToCode(block, inputNames.catch)
    const statementsFinallyPart = Blockly.JavaScript.statementToCode(block, inputNames.finally)
    let catchCode = statementsCatchPart
      ? ` catch(${textErrorVariable}) {\n${statementsCatchPart}}`
      : ''
    const finallyCode = statementsFinallyPart ? ` finally {\n${statementsFinallyPart}}` : ''
    if (!catchCode && !finallyCode) {
      catchCode = ' catch(e) {}'
    }
    const code = `try {\n${statementsTryPart}}${catchCode}${finallyCode}\n`
    return code
  }
)
